import React, { useRef, useEffect, useState } from 'react'
import moment from 'moment'
import axios from '../../plugins/axios';
import { useTranslation } from 'react-i18next';
import { mmHgToKPa, celsiusToFahrenheit, percentTommHg,percentToKpa,mmHgToPercent } from '../../plugins/common'
import { useRecoilState } from 'recoil';
import { selectBedInfoState,unitState,isFromSearchState } from '../../plugins/recoil';
import {ReactComponent as IconArrowDown} from '../../assets/icons/ic-arrow-down.svg'
import { ReactComponent as IconPrint } from '../../assets/icons/ic-print.svg'
import './TabularTrend.scss'

//const filterParameter = ['timestamp','patientId','patientName','etCo2','gasCo2','gasDes','gasN2o','gasO2','gasSev']

const TabularTrend = ({ isTrendFull, onClose, selectBoxTimeInfo, handleSelectBoxTimeInfo, waveStartDate, waveEndDate, trendZoom, handleTrendPrint}) => {
    const { t } = useTranslation()
    const tableContainerRef = useRef(null)    
    const [selectBedInfo, ] = useRecoilState(selectBedInfoState)
    const [isFromSearch, ] = useRecoilState(isFromSearchState)
    const [units,] = useRecoilState(unitState);
    const [detailData, setDetailData] = useState([])    
    const [detailDataKeys, setDetailDataKeys] = useState([])    
    const [width, setWidth] = useState();

    const isSelected = (targetTimeString) => {
        if (!selectBoxTimeInfo) return false
        if (moment(selectBoxTimeInfo).format('HH:mm:ss') === targetTimeString) return true
        return false
    }

    console.log('units : ',units);
    
    //API에서 날라오는 파라미터 네이밍 재 변환을 위한 정리.
    const TrendType = {
        "hr" : "HR/PR",
        "arrhythmia" : "Arrhythmia",
        "spo2Percent" : "SpO2",
        "rrRpm" : "RR",
        "temp1C" : "Temp1",
        "temp2C" : "Temp2",
        "awrrRpm" : "awRR",
        "ibp1" : "IBP 1",
        "ibp2" : "IBP 2",
        "ibp3" : "IBP 3",
        "ibp4" : "IBP 4",
        "nibp" : "NIBP",     
        "gasCo2" : "Gas CO2",
        "gasDes" : "Gas DES",
        "gasN2o" : "Gas N2O",
        "gasO2" : "Gas O2",
        "gasSev" : "Gas SEV",
        "etCo2" : "EtCO2",
        "inCo2" : "InCO2",
        "ipi" : "IPI",   
    }

    //API에서 넘어오는 파라미터 정리.
    const UnitType = {
        "hr" : "HR",
        "arrhythmia" : "arrhythmia",
        "spo2Percent" : "SpO2",
        "rrRpm" : "RR",
        "temp1C" : "Temp1",
        "temp2C" : "Temp2",
        "awrrRpm" : "awRR",
        "ibp1" : "IBP1",
        "ibp2" : "IBP2",
        "ibp3" : "IBP3",
        "ibp4" : "IBP4",
        "nibp" : "NIBP",
        "gasCo2" : "gasCo2",
        "gasDes" : "gasDes",
        "gasN2o" : "gasN2o",
        "gasO2" : "gasO2",
        "gasSev" : "gasSev",
        "etCo2" : "EtCO2",
        "inCo2" : "InCO2",
        "ipi" : "IPI",
    }

    const getTabularTrendData = async () => {
        try{
            const res = await axios.get(`/trend/tabular/vitals?serialNo=${selectBedInfo?.serial}&startTime=${moment.utc(waveStartDate).format('YYYY-MM-DDTHH:mm:ss')}Z&endTime=${moment.utc(waveEndDate).format('YYYY-MM-DDTHH:mm:ss')}Z`);
            //setTabularTrendData(res.data.data)                  
            
            const data = res.data.data;
            if(data.length > 0){
                setDetailData(data)
                setDetailDataKeys(Object.keys(data[0]).filter(keyName => keyName != "timestamp" && keyName != "patientId" && keyName != "patientName"))
                const key = Object.keys(data[0]).filter(keyName => keyName !== "timestamp" && keyName !== "patientId" && keyName !== "patientName");
                setWidth(key.length*144);
            }else{
                setDetailData([])
                setDetailDataKeys([])
                setWidth(0);
            }
        }
        catch(err){
            console.warn('getTabularTrendData error:', err);
        }
    }

    //Search 기준 알람 데이터를 가져오는 로직
    const getIsSearchTabularTrendData = async () => {
        try{
            const deviceHistory = selectBedInfo?.deviceHistory || [];
            const searchStart = moment(waveStartDate);
            const searchEnd = moment(waveEndDate);

            // 1. 환자별 입퇴원 기간 생성 (시리얼 기준)
            const periods = [];
            const sortedHistory = deviceHistory.slice().sort((a, b) => moment(a.createdAt) - moment(b.createdAt));
            let currentPeriod = null;
            sortedHistory.forEach(h => {
                if (h.action === 'ADMITTED') {
                    currentPeriod = {
                        serial: h.serial,
                        start: moment(h.createdAt),
                        end: null
                    };
                } else if (h.action === 'UNASSIGNED' && currentPeriod) {
                    currentPeriod.end = moment(h.createdAt);
                    periods.push(currentPeriod);
                    currentPeriod = null;
                }
            });
            if (currentPeriod && !currentPeriod.end) {
                currentPeriod.end = moment(); // 현재까지 입원
                periods.push(currentPeriod);
            }

            // 2. 검색 구간과 겹치는 기간만 추출
            const plans = [];
            periods.forEach(period => {
                const planStart = moment.max(searchStart, period.start);
                const planEnd = moment.min(searchEnd, period.end);
                if (planEnd.isAfter(planStart)) {
                    plans.push({
                        serial: period.serial,
                        start: planStart,
                        end: planEnd
                    });
                }
            });

            // 3. 각 구간별로 알람 데이터 가져오기
            let tabular = [];
            for (const plan of plans) {
                const res = await axios.get(`/trend/tabular/vitals?serialNo=${plan.serial}&startTime=${plan.start.utc().format('YYYY-MM-DDTHH:mm:ss')}Z&endTime=${plan.end.utc().format('YYYY-MM-DDTHH:mm:ss')}Z`);
                if (res.code != '200') throw res;
                const data = res.data.data;              
                tabular = tabular.concat(data);
            }

            if(tabular.length > 0){
                setDetailData(tabular)
                setDetailDataKeys(Object.keys(tabular[0]).filter(keyName => keyName != "timestamp" && keyName != "patientId" && keyName != "patientName"))
                const key = Object.keys(tabular[0]).filter(keyName => keyName !== "timestamp" && keyName !== "patientId" && keyName !== "patientName");
                setWidth(key.length*144);
            }else{
                setDetailData([])
                setDetailDataKeys([])
                setWidth(0);
            }
        }
        catch(err){
            console.warn(err.message);
        }
    }

    const convertUnit = (parameter,value) => {
        const nibpSeries = ['NIBP']
        const ibpSeries = ['IBP1', 'IBP2', 'IBP3', 'IBP4']
        const co2Series = ['EtCO2', 'InCO2']
        const tempSeries = ['Temp1', 'Temp2']        
        const gasSeries = ['gasCo2', 'gasDes', 'gasN2o', 'gasO2', 'gasSev']
        const otherSeries = ['HR', 'RR', 'awRR', 'SpO2', 'arrhythmia', 'IPI']        

            //함수를 유동적으로 사용해보고 싶어서 써봄.
        const convertFunctions = {
            mmHgToKPa,
            celsiusToFahrenheit,
            percentTommHg,
            percentToKpa,
            mmHgToPercent
        };

        let unit = undefined;
        let functionName = undefined;                

        if (nibpSeries.includes(parameter)) {
            unit = units["NIBP"];
            if(unit === 'kPa') {
                functionName = 'mmHgToKPa'; // mmHg를 kPa로 변환하는 함수
            }
        } else if (ibpSeries.includes(parameter)) {
            const prefix = parameter.match(/^IBP[1-4]/)?.[0];  // "IBP1", "IBP2" 등 추출
            unit = units[prefix];
            if(unit === 'kPa') {
                functionName = 'mmHgToKPa'; // mmHg를 kPa로 변환하는 함수
            }
        } else if (co2Series.includes(parameter)) {            
            unit = units[parameter];            
            if(unit === 'kPa') {
                functionName = 'mmHgToKPa'; // mmHg를 kPa로 변환하는 함수
            }
            else if(unit === '%'){
                functionName = 'mmHgToPercent'; // mmHg를 %로 변환하는 함수
            }
        } else if (tempSeries.includes(parameter)) {
            unit = units[parameter];
            if(unit === '°F') {
                functionName = 'celsiusToFahrenheit'; // 섭씨를 화씨로 변환하는 함수
            }
        } 
        else if (gasSeries.includes(parameter)) {                       
            unit = units['GAS'];
            if(unit === 'mmHg') {
                functionName = 'percentTommHg'; // mmHg를 kPa로 변환하는 함수
            }
            else if(unit === 'kPa'){
                functionName = 'percentToKpa';
            } 
        } else if(otherSeries.includes(parameter)) {
            unit = units[parameter];
        }

        let label = value;
        if (functionName && typeof convertFunctions[functionName] === 'function') {
            if(nibpSeries.includes(parameter) || ibpSeries.includes(parameter) || gasSeries.includes(parameter)){                
                const splitValue = value.split('/');
                let newLabel = '';
                splitValue.map((value,index) => {                    
                    const convertedValue = value === '-' ? '-' : String(convertFunctions[functionName](value));
                    newLabel += convertedValue + `${index == splitValue.length - 1 ? '' : '/'}`;                    
                })
                label = newLabel;
            }
            else {
                if(value == '-'){
                    return value;
                }else{
                    label = convertFunctions[functionName](value);
                }
            }
        }
        return label;
    }

    useEffect(() => {
        if(isFromSearch){
            getIsSearchTabularTrendData();
        }else{
            getTabularTrendData();    
        }
    }, [waveStartDate,trendZoom]);

    useEffect(() => {
        if (tableContainerRef.current) {
            tableContainerRef.current.scrollLeft = 0            
        }
    }, [detailData])

    // useEffect(() => {
    //     if (!selectBoxTimeInfo || !tableContainerRef.current) return;

    //     // 해당 row의 index 찾기
    //     const idx = detailData.findIndex(item => 
    //         moment(item.timestamp).format('HH:mm:ss') === moment(selectBoxTimeInfo).format('HH:mm:ss')
    //     );
    //     if (idx === -1) return;

    //     // tbody > tr 들을 가져와서 해당 row로 스크롤
    //     const tableRows = tableContainerRef.current.querySelectorAll('tbody tr');
    //     if (tableRows[idx]) {
    //         tableRows[idx].scrollIntoView({ block: 'center' });
    //     }
    // }, [selectBoxTimeInfo, detailData]);
    useEffect(() => {
        if (!selectBoxTimeInfo || !tableContainerRef.current) return;

        // 해당 row의 index 찾기
        const idx = detailData.findIndex(item => 
            moment(item.timestamp).format('HH:mm:ss') === moment(selectBoxTimeInfo).format('HH:mm:ss')
        );
        if (idx === -1) return;

        // 현재 스크롤 위치의 row index 계산
        const tableRows = tableContainerRef.current.querySelectorAll('tbody tr');
        const currentScrollTop = tableContainerRef.current.scrollTop;
        let currentIdx = 0;
        if (tableRows.length > 0) {
            // 각 row의 offsetTop을 비교해서 현재 보이는 row index 추정
            for (let i = 0; i < tableRows.length; i++) {
                if (tableRows[i].offsetTop > currentScrollTop) {
                    currentIdx = i;
                    break;
                }
            }
        }

        // 현재 row의 시간과 selectBoxTimeInfo의 시간 차이 계산 (초 단위)
        const currentTime = detailData[currentIdx]?.timestamp;
        const diffSeconds = Math.abs(moment(currentTime).diff(moment(selectBoxTimeInfo), 'seconds'));

        // 60초 이내면 스크롤 이동하지 않음
        if(isTrendFull){
            if (diffSeconds <= 240) return;
        }else{
            if (diffSeconds <= 60) return;
        }

        // tbody > tr 들을 가져와서 해당 row로 스크롤
        if (tableRows[idx]) {
            tableRows[idx].scrollIntoView({ block: 'center' });
        }
    }, [selectBoxTimeInfo, detailData]);

    return (
        <div className="relative h-full bg-[#2F2F2F]" style={{ width: 'calc(100% - 48px)' }}>
            <div className="flex justify-between items-center h-[40px] px-[20px]">
                <h2 className="text-white text-center font-medium text-lg leading-[110%] font-pretendard">{t('trend.tabularTrend')}</h2>
                <div className='flex flex-nowrap gap-[12px]'>
                    <div className="flex items-center justify-center cursor-pointer text-white rounded-[4px] border border-[#5E5E5E] bg-gradient-to-b from-[#5E5E5E] to-[#383838] p-[4px]" onClick={handleTrendPrint}>
                        <IconPrint className="w-[18px] h-[18px] text-white" />
                    </div>
                    {
                        isTrendFull && (
                            <div className="flex items-center justify-center cursor-pointer text-white rounded-[4px] border border-[#5E5E5E] bg-gradient-to-b from-[#5E5E5E] to-[#383838] p-[4px]" onClick={onClose}>
                                <IconArrowDown className="w-[18px] h-[18px] text-white" />
                            </div>
                        )
                    }
                </div>                
            </div>   
            <div className={`flex-1 trend-review-wrapper h-full`} style={{ minHeight: isTrendFull ? '370px' : '148px', maxHeight: isTrendFull ? '370px' : '148px'}}>
                <div ref={ tableContainerRef } className={`table-container ${width > 0 ? 'scrollbar scrollbar-x scrollbar-x-10px' : ''}`}>
                    <table style={{ borderCollapse: "collapse", width: width == 0 ? '100%' : width, textAlign: "center" }}>
                        <thead>
                            <tr style={{ borderBottomWidth: 1, borderColor: '#4E4E4E', fontWeight: 300, fontSize: 14, lineHeight: '15.4px' }}>
                                {
                                    detailDataKeys.length > 0 && (
                                        <>
                                            <th className="fixed-left bg-[#262626] w-[150px] h-[42px]" style={{ top: -1, zIndex: 4, minWidth: 150, maxWidth: 150}}>
                                                {t('trend.time')}
                                            </th>
                                            {
                                                // error 일때 나중에 추가해야됨
                                                // <td className="error">80</td>
                                                detailDataKeys.map(((keyName, idx) => {
                                                    return (
                                                        <th 
                                                            key={`trend-review-data-timestampstr-${idx}`} 
                                                            className={`${idx !== detailDataKeys.length - 1 ? 'right-border' : ''} bg-[#262626] w-[144px] h-[42px]`}>                                                            
                                                            {TrendType[keyName] || keyName}
                                                            {
                                                                ['gasCo2', 'gasDes', 'gasN2o', 'gasO2', 'gasSev'].includes(keyName)
                                                                    ? (units['GAS'] && ` (${units['GAS']})`)
                                                                    : (units[UnitType[keyName]] && ` (${units[UnitType[keyName]]})`)
                                                            }
                                                        </th>
                                                    )
                                                }))
                                            }
                                        </>
                                    )
                                }
                            </tr>
                        </thead>
                        <tbody>
                        {
                            detailDataKeys.length > 0 ?                        
                            detailData.map((item, idx) => {
                                return (
                                    <tr key={`trend-review-data-key-${idx}`} className={`${idx % 2 === 1 ? 'highlight' : ''}`}>
                                        <td
                                            className={`fixed-left ${idx % 2 === 1 ? 'bg-[#383838]' : 'bg-[#2F2F2F]'} ${isSelected(moment(item.timestamp).format('HH:mm:ss')) ? 'selected': ''}`}
                                            onClick={() => { handleSelectBoxTimeInfo(moment(item.timestamp)); }}
                                        >
                                            {moment(item.timestamp).format('HH:mm:ss')}
                                        </td>
    
                                        {
                                            detailDataKeys.map((keyName, keyDataIdx) => {                                                
                                                const keyDetailData = item[keyName].value
                                                const keyDetailAlarm = item[keyName].priority                                                
                                                return (
                                                    <td 
                                                        onClick={() => { handleSelectBoxTimeInfo(moment(item.timestamp));}}
                                                        key={`trend-review-data-${item}-${keyName}-${keyDataIdx}`}                                                                                                        
                                                        className={`${keyDataIdx !== detailData.length - 1 ? 'right-border' : ''} ${ idx % 2 === 1 ? '' : 'bg-[#2F2F2F]' } ${keyDetailData !== "-" && (keyDetailAlarm == "2" ? "bg-[#602D36]" : (keyDetailAlarm == "1" || keyDetailAlarm == "0") ? "bg-[#605E2D]" : "")}`}>                                                             
                                                            {
                                                                convertUnit(UnitType[keyName], keyDetailData)
                                                            }
                                                    </td>
                                                )
                                            }) 
                                        }
                                    </tr>
                                )
                            }) :
                            <tr className="flex items-center justify-center" style={{ marginTop: 60 }}>
                                <td>{t('error.noDataAvailable')}</td>
                            </tr>
                        }                    
                        </tbody>
                    </table>
    
                </div>
            </div>
        </div>
    );
};

export default TabularTrend;
